type TrialWorkspace = {
  resourceId: string; accountId: string; canManageBilling: boolean;
  entitlement: { requiresTrialConversion?: boolean };
};
// Only centrally confirmed trial expiry can trigger a payment redirect. Suspensions
// and expired paid access must keep their separate recovery screens.
export function redirectToTrialBilling(workspace: TrialWorkspace | undefined, portal: string,
  replace: (url: string) => void = url => window.location.replace(url)): boolean {
  if (!workspace?.canManageBilling || !workspace.entitlement.requiresTrialConversion) return false;
  replace(`${portal.replace(/\/$/, '')}/subscriptions/${encodeURIComponent(workspace.resourceId)}?accountId=${encodeURIComponent(workspace.accountId)}&paymentRequired=trial`);
  return true;
}
